module.exports = __webpack_public_path__ + "img/calendar-minus-01.a8a71d5f.svg";